import { contoursToPath2D } from './flatten';
import type { TextSettings } from './settings';
import type { TextField } from './textField';

type Ctx2D = CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;

/**
 * Draws the glyphs themselves, honouring the fill/stroke/mask render modes.
 *
 * Lives in `core` rather than in the UI because both the live preview and the exporter
 * need it, and the exporter must not reach into UI code.
 */
export function drawText(ctx: Ctx2D, field: TextField, settings: TextSettings, color = '#f2f2f7'): void {
  if (!settings.visible || settings.renderMode === 'mask' || field.isEmpty) return;

  const path = contoursToPath2D(field.contours);
  if (settings.renderMode === 'fill' || settings.renderMode === 'fillStroke') {
    ctx.fillStyle = color;
    ctx.fill(path, 'nonzero');
  }
  if (settings.renderMode === 'stroke' || settings.renderMode === 'fillStroke') {
    ctx.strokeStyle = color;
    ctx.lineWidth = settings.strokeWidth;
    ctx.lineJoin = 'round';
    ctx.stroke(path);
  }
}
